import { generateUtilityClasses, styled } from '@mui/material';

const COMPONENT_NAME = 'PrcPageLayout';

// Generating utility classes for inner stacks to target on sx styling if required
// No props forwards needed as it's just layout and styling can be applied this way
export const pageLayoutClasses = {
  ...generateUtilityClasses(COMPONENT_NAME, ['root', 'content', 'fullHeight']),
};

const forwardProps: Record<string, true> = {
  fullHeight: true,
  disablePadding: true,
};

export const Root = styled('div', { shouldForwardProp: (prop) => !forwardProps[prop as string] })<{
  fullHeight?: boolean;
  disablePadding?: boolean;
}>(({ fullHeight, disablePadding, theme }) => ({
  padding: disablePadding ? 0 : theme.spacing(4),

  ...(fullHeight
    ? {
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        padding: 0,
      }
    : undefined),
}));

export const Content = styled('div', { shouldForwardProp: (prop) => prop !== 'disablePadding' })<{
  disablePadding?: boolean;
}>(({ disablePadding, theme }) => ({
  flex: '1 1 auto',
  display: 'flex',
  padding: disablePadding ? 0 : theme.spacing(4),
}));
